module.exports = __webpack_public_path__ + "img/25.e6ec722e.jpg";